class TreasuryDelegate {
    handleDateChange(dates) {
        this.setState({ dateRange: dates });
        if (dates && dates.length === 2) {
            // Reload data with new date range
            this.loadDataWithDateRange(dates[0], dates[1]);
        }
    }
}

export default TreasuryDelegate;
